<template>
    <div>
        <h3 class="subtitle is-3 has-text-centered">
            <span>{{ titleLabel }}</span>
            <span v-if="type != 'graduate' && type != 'master' && type != 'bachelor'">
                ({{ studentTypeLabel }})
            </span>
        </h3>

        <div class="columns" v-if="type != 'graduate' && type != 'master' && type != 'bachelor'">
            
            <div class="column" v-if="!exists">

                <b-field
                    expanded
                    :label="messages.students.type.title">
                    <b-select
                        @input="onTypeChange"
                        expanded
                        v-model="item.student_type">
                            <option v-for="type in studentTypes" :value="type" :key="type">
                                {{ messages.students.type[type] }}
                            </option>
                    </b-select>
                </b-field>

            </div>
            
            <div class="column" v-if="!exists">

                <b-field label="Год начала обучения" expanded>
                    <b-input
                        v-model="item.enrollment_year"
                        @input="modify"
                        type="number"
                        step="1"
                        :min="currentYear - 4"
                        :max="+currentYear + 1">
                    </b-input>
                </b-field>

            </div>
            
            <div class="column" v-if="type == 'regular' || type == 'linguistic'"
                :class="{ 'is-half': exists }">

                <b-field label="Номер" expanded>
                    <b-input
                        v-model="item.details.number"
                        @input="modify"
                        type="number"
                        step="1"
                        min="1"
                        max="99">
                    </b-input>
                </b-field>

            </div>

        </div>

        <div class="columns" v-if="type == 'linguistic'">
            
            <div class="column">

                <b-field
                    label="Тип языка">

                    <b-field>

                        <b-radio-button
                            @input="onTypeChange"
                            class="is-expanded"
                            v-model="languageType"
                            native-value="primary">
                            <span>Первый</span>
                        </b-radio-button>

                        <b-radio-button
                            @input="onTypeChange"
                            class="is-expanded"
                            v-model="languageType"
                            native-value="secondary">
                            <span>Второй</span>
                        </b-radio-button>

                    </b-field>
                    
                </b-field>

            </div>
            
            <div class="column">

                <b-field
                    expanded
                    label="Язык">
                    <b-select
                        @input="modify"
                        expanded
                        placeholder="Нет языков для данного типа"
                        :disabled="this.item.details.subject == null"
                        v-model="item.details.subject">
                            <option
                                v-for="subject in filteredSubjects"
                                :value="subject.id"
                                :key="subject.id"
                                v-text="subject.title"
                            />
                    </b-select>
                </b-field>

            </div>

        </div>

        <div class="columns" v-if="type == 'bachelor'">
            
            <div class="column">
                <b-field
                    expanded
                    label="Кафедра">
                    <b-select
                        expanded
                        @input="modify"
                        v-model="item.details.department">
                        <option :value="null">
                            Выберите кафедру
                        </option>
                        <option
                            v-for="department in departments"
                            :value="department.id"
                            :key="department.id"
                            v-text="department.name"
                        />
                    </b-select>
                </b-field>
            </div>
            
            <div class="column is-one-third">

                <b-field label="Аббревиатура" expanded>
                    <b-input
                        maxlength="64"
                        @input="modify"
                        name="abbreviation"
                        :placeholder="titleLabel"
                        v-model="item.details.abbreviation"
                        expanded>
                    </b-input>
                </b-field>

            </div>
        
        </div>

        <div class="columns" v-else-if="type == 'master'">

            <div class="column">
                <b-field
                    expanded
                    label="Магистерская программа">
                    <b-select
                        expanded
                        @input="modify"
                        v-model="item.details.program">
                        <option :value="null">
                            Выберите кафедру
                        </option>
                        <option
                            v-for="program in masterPrograms"
                            :value="program.id"
                            :key="program.id"
                            v-text="program.name"
                        />
                    </b-select>
                </b-field>
            </div>

        </div>

        <div class="columns" v-else-if="type == 'graduate'">

            <div class="column">
                <b-field
                    expanded
                    label="Направление подготовки">
                    <b-select
                        expanded
                        @input="modify"
                        v-model="item.details.profile">
                        <option :value="null">
                            Выберите направление
                        </option>
                        <option
                            v-for="profile in graduateProfiles"
                            :value="profile.id"
                            :key="profile.id"
                            v-text="profile.course"
                        />
                    </b-select>
                </b-field>
            </div>

        </div>

        <div class="columns" v-if="type == 'bachelor' || type == 'master' || type == 'graduate'">
            
            <div class="column is-half">

                <b-field label="Год начала обучения" expanded>
                    <b-input
                        :disabled="exists"
                        v-model="item.enrollment_year"
                        @input="modify"
                        type="number"
                        step="1"
                        :min="currentYear - 4"
                        :max="+currentYear + 1">
                    </b-input>
                </b-field>

            </div>

        </div>
        
        <div class="columns" v-if="type == 'optional'">

            <div class="column">
                <b-field
                    expanded
                    label="Кафедра">
                    <b-select
                        expanded
                        @input="onDepartmentChange"
                        v-model="filterDepartment">
                        <option :value="null">
                            Любая
                        </option>
                        <option
                            v-for="department in departments"
                            :value="department"
                            :key="department.id"
                            v-text="department.name"
                        />
                    </b-select>
                </b-field>
            </div>

        </div>
        
        <div class="columns" v-if="type == 'optional'">
            
            <div class="column">

                <b-field
                    expanded
                    label="Дисциплина">
                    <b-select
                        @input="modify"
                        expanded
                        placeholder="Нет дисциплин для курсов по выбору"
                        :disabled="this.item.details.subject == null"
                        v-model="item.details.subject">
                            <option
                                v-for="subject in filteredSubjects"
                                :value="subject.id"
                                :key="subject.id"
                                v-text="subject.title"
                            />
                    </b-select>
                </b-field>

            </div>

        </div>
    </div>
</template>
<script>
import toasts from "../../mixins/toasts";
import messages from "../../mixins/messages";

export default Vue.extend({
  props: {
    type: {
      type: [String],
      default: "regular"
    },
    preset: {
      type: [Object]
    },
    currentYear: {
      type: [String]
    },
    exists: Boolean,
    subjects: Array,
    departments: Array,
    graduateProfiles: Array,
    masterPrograms: Array
  },
  mixins: [toasts, messages],
  data() {
    return {
      item: {
        details: {}
      },
      studentTypes: ["bachelor", "master", "graduate"],
      filterDepartment: null,
      languageType: "primary"
    };
  },
  created() {
    // Use preset data to populate item.
    // This is generated to the server and passed from parent component.
    this.item = this.preset;

    switch (this.type) {
      case "graduate": {
        let profile = _.find(this.graduateProfiles, {
          id: _.get(this.item.details, "profile.id", this.item.details.profile)
        });

        if (profile) {
          this.item.details.profile = profile.id;
        }
        break;
      }
      case "master": {
        let program = _.find(this.masterPrograms, {
          id: _.get(this.item.details, "program.id", this.item.details.program)
        });

        if (program) {
          this.item.details.program = program.id;
        }
        break;
      }
      case "bachelor": {
        let department = _.find(this.departments, {
          id: _.get(
            this.item.details,
            "department.id",
            this.item.details.department
          )
        });

        if (department) {
          this.item.details.department = department.id;
        }
        break;
      }
      case "linguistic": {
        let subject = _.find(this.subjects, {
          id: _.get(this.item.details, "subject.id", this.item.details.subject)
        });

        if (subject) {
          this.languageType = subject.linguistic;
          this.item.details.subject = subject.id;
        }
        break;
      }
      case "optional": {
        let subject = _.find(this.subjects, {
          id: _.get(this.item.details, "subject.id", this.item.details.subject)
        });

        if (subject) {
          this.item.details.subject = subject.id;
        }

        if (this.exists) {
          let subject = _.find(this.subjects, {
            id: this.item.details.subject
          })

          this.filterDepartment = _.find(this.departments, {
            id: _.get(subject.details, 'department.id')
          })
        }
        break;
      }
    }

    if (this.type != "master" && this.type != "bachelor" && this.type != "optional") {
      if (this.item.details.number < 99) {
        if (!this.exists) {
          this.item.details.number++;
        }
      } else {
        this.item.details.number = 99;
      }
    }
  },
  computed: {
    studentTypeLabel() {
      return this.messages.students.type[this.item.student_type];
    },
    titleLabel() {
      let course = this.currentYear - this.item.enrollment_year + 1;
      if (course < 1) {
        course = 1;
      } else if (course > 5) {
        course = 5;
      }

      switch (this.item.student_type) {
        case "bachelor": {
          if (course > 4) {
            course = 4;
          }
          break;
        }
        case "master":
        case "graduate": {
          if (course > 2) {
            course = 2;
          }
          break;
        }
        case "aspirant": {
          if (course > 3) {
            course = 3;
          }
          break;
        }
      }

      let number = this.item.details.number;
      if (number < 1) {
        number = 1;
      } else if (number > 99) {
        number = 99;
      }

      let title;

      switch (this.type) {
        case "linguistic": {
          let subject = _.find(this.filteredSubjects, {
            id: this.item.details.subject
          });

          if (subject) {
            if (this.item.details.number > 0) {
              title = `${subject.title} ${number}`;
            } else {
              title = subject.title;
            }
          }
          break;
        }
        case "graduate": {
          if (this.item.details.profile) {
            title = _.get(
              _.find(this.graduateProfiles, {
                id: this.item.details.profile
              }),
              "course"
            );
          }
          break;
        }
        case "master": {
          if (this.item.details.program) {
            title = _.get(
              _.find(this.masterPrograms, {
                id: this.item.details.program
              }),
              "abbreviation"
            );
          }
          break;
        }
        case "bachelor": {
          if (this.item.details.abbreviation) {
            return this.item.details.abbreviation;
          } else if (this.item.details.department) {
            title = _.get(
              _.find(this.departments, {
                id: this.item.details.department
              }),
              "abbreviation"
            );
          }
          break;
        }
        case "optional": {
          let subject = _.find(this.filteredSubjects, {
            id: this.item.details.subject
          });

          if (subject) {
            title = subject.title;
          }
          break;
        }
        default: {
          title = "Учебная группа " + course + _.padStart(number, 2, 0);
          break;
        }
      }

      return title ? title : "-";
    },
    filteredSubjects() {
      let subjects = this.subjects;

      let filter = {
        student_type: this.item.student_type
      };

      switch(this.type) {
        case 'linguistic': {
          filter = _.merge(filter, {
            linguistic: this.languageType
          });
          break;
        }
        case 'optional': {
          if(this.filterDepartment) {
            filter = _.merge(filter, {
              details: {
                department: {
                  id: _.get(this.filterDepartment, 'id')
                }
              }
            });
          }
          break;
        }
      }

      subjects = _.filter(subjects, filter);

      return subjects;
    }
  },
  methods: {
    populate(data) {
      this.item = data;
      this.modify();
    },
    modify() {
      this.$emit("modified");
    },
    refreshSubjectList() {
      if (this.filteredSubjects.length > 0) {
        this.item.details.subject = this.filteredSubjects[0].id;
      } else {
        this.item.details.subject = null;
      }
    },
    onTypeChange() {
      this.refreshSubjectList();
      this.modify();
    },
    onDepartmentChange() {
      this.refreshSubjectList();
      this.modify();
    },
    save: function() {
      return new Promise((resolve, reject) => {
        if (this.exists) {
          let loading = this.$loading.open();
          axios
            .put(`/api/groups/${this.item.id}`, this.item)
            .then(response => {
              resolve(response.data);
              this.toast("success", "Группа была успешно обновлена");
              loading.close();
            })
            .catch(error => {
              switch (error.response.status) {
                case 422: {
                  this.toast("error", "@validate");
                  break;
                }
                case 409: {
                  this.toast("warning", "Такая группа уже существует");
                  break;
                }
                case 403: {
                  this.toast(
                    "warning",
                    "Создание группы с такими параметрами недоступно"
                  );
                  break;
                }
                default: {
                  this.toast("error", "@unexpected", error);
                }
              }
              loading.close();
              reject();
            });
        } else {
          // First validate the data.
          let data = _.omit(this.item, ["id"]);
          axios
            .post(`/api/groups/validate`, data)
            .then(response => {
              // If entered data is valid, try to create new group.
              let loading = this.$loading.open();
              axios
                .post(`/api/groups`, data)
                .then(response => {
                  loading.close();
                  resolve(response.data);
                })
                .catch(error => {
                  switch (error.response.status) {
                    case 403: {
                      this.toast(
                        "warning",
                        "Создание группы с такими параметрами недоступно"
                      );
                      break;
                    }
                    default: {
                      this.toast("error", "@unexpected", error);
                    }
                  }
                  loading.close();
                  reject();
                });
            })
            .catch(error => {
              // Otherwise catch the error and display it to the user.
              switch (error.response.status) {
                case 409: {
                  this.toast("warning", "Такая группа уже существует");
                  break;
                }
                case 422: {
                  this.toast("error", "@validate");
                  break;
                }
                default: {
                  this.toast("error", "@unexpected", error);
                }
              }
              this.loading = false;
            });
        }
      });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/models/Group.vue